import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './services/security/interceptor.service';
import { MessageService } from 'primeng/api';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from './services/security/authentication.service';

export function initializeAuthentication(authService: AuthenticationService): () => Promise<string | null> {
    return () => {
        return firstValueFrom(authService.fetchToken('denuncias-app')).catch((error) => {
            console.error('No se pudo inicializar el token al arrancar la app:', error);
            return Promise.resolve(null);
        });
    };
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        RecaptchaV3Module
    ],
    providers: [
        MessageService, // Agregar MessageService a los proveedores
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAuthentication,
            deps: [AuthenticationService],
            multi: true
        },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha_v3_site_key
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
